import { Button } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import React, { useState, memo } from "react";
import MenuOptions from "../threeDots/Menu";

const CollapsibleCategory = ({
  item,
  clickHandlerEDIT = () => {},
  clickHandlerDELETE = () => {},
  modalHandler,
  modal,
  child,
  parent,
}) => {
  const [open, setOpen] = useState(false);
  if (item?.children?.length > 0) {
    return (
      <>
        <tr
          className={`${child ? "child" : ""} `}
        >
          <td>
            <Button onClick={() => setOpen(!open)}>
              {open ? <ExpandLess /> : <ExpandMore />}
            </Button>
          </td>
          <td>{item.id}</td>
          <td>{item.nameEn}</td>
          <td>{item.nameRu}</td>
          <td>{item.nameUz}</td>
          <td>
            <span>{item.price}</span>
          </td>
          <td>
            <MenuOptions
              options={[
                {
                  value: "Изменить",
                  callback: () => {
                    clickHandlerEDIT(item, parent);
                    modalHandler(true);
                  },
                },
                {
                  value: "Удалить",
                  callback: () => {
                    clickHandlerDELETE(item.id);
                    // modalHandler(true);
                  },
                },
              ]}
            />
          </td>
        </tr>
        {open &&
          item.children.map((v, index) => (
            <CollapsibleCategory
              key={index}
              child={true}
              clickHandlerEDIT={clickHandlerEDIT}
              clickHandlerDELETE={clickHandlerDELETE}
              parent={item}
              modal={modal}
              modalHandler={modalHandler}
              item={v}
            />
          ))}
      </>
    );
  } else
    return (
      <tr key={item.id} className={`${child ? "child" : ""} `}>
        <td></td>
        <td>{item.id}</td>
        <td>{item.nameEn}</td>
        <td>{item.nameRu}</td>
        <td>{item.nameUz}</td>
        <td>
          <span>{item.price}</span>
        </td>
        <td>
          <MenuOptions
            options={[
              {
                value: "Изменять",
                callback: () => {
                  clickHandlerEDIT(item, parent);
                  modalHandler(true);
                },
              },
              {
                value: "Удалить",
                callback: () => {
                  clickHandlerDELETE(item.id);
                  // modalHandler(true);
                },
              },
            ]}
          />
        </td>
      </tr>
    );
};

export default memo(CollapsibleCategory);
